import { COMPONENT_HUB_API_PATH } from '@config/constant';

export const PROFILE_API_PREFIX = `${COMPONENT_HUB_API_PATH}/profile`;


